import { render } from "./SupportModalDynamic.vue?vue&type=template&id=56538a9a"
import script from "./SupportModalDynamic.vue?vue&type=script&lang=js"
export * from "./SupportModalDynamic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/SupportModalDynamic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56538a9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56538a9a', __exports__)) {
    api.reload('56538a9a', __exports__)
  }
  
  module.hot.accept("./SupportModalDynamic.vue?vue&type=template&id=56538a9a", () => {
    api.rerender('56538a9a', render)
  })

}


export default __exports__